import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AllProductsPage from "@/pages/AllProductsPage";
import QuestionnairePage from "@/pages/QuestionnairePage";
import RecommendationPage from "@/pages/RecommendationPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CalculatorPage from "@/pages/CalculatorPage";

// Admin Pages
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminLeads from "@/pages/admin/AdminLeads";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<AllProductsPage />} />
          <Route path="/products/:productId" element={<ProductDetailPage />} />
          <Route path="/questionnaire/:category" element={<QuestionnairePage />} />
          <Route path="/recommendation/:category" element={<RecommendationPage />} />
          <Route path="/calculator" element={<CalculatorPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/questions" element={<AdminQuestions />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
